import React from "react";
import { View, StyleSheet, Image } from "react-native";

function NtImageBackground({
  containerStyle,
  imageStyle,
  opaqueStyle,
  image,
  opacity = 0.6,
}) {
  return (
    <View style={[styles.container, containerStyle]}>
      <Image
        style={[
          {
            width: "100%",
            height: "100%",
            position: "absolute",
          },
          imageStyle,
        ]}
        source={image}
      />
      <View
        style={[
          {
            width: "100%",
            height: "100%",
            backgroundColor: `rgba(0, 0, 0, ${opacity})`,
            position: "absolute",
          },
          opaqueStyle,
        ]}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    width: "100%",
    height: 600,
  },
});

export default NtImageBackground;
